/** VK Ads / Top.Mail.Ru counter id (должен совпадать со сниппетом в index.html). */
export const TOP_MAIL_RU_COUNTER_ID = "3760703";
